export const authConstants = {
    LOADING:"LOADING",
    LOGIN_SUCCESS:"LOGIN_SUCCESS",
    RESET_PASSWORD:"RESET_PASSWORD",
    FORGOT_PASSWORD:"FORGOT_PASSWORD",
    RESPONSE_STATE:"RESPONSE_STATE",
    RESPONSE:"RESPONSE",
    LOG_OUT: "LOG_OUT",
}